// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TrademarksPage from './pages/TrademarksPage';
import CategoriesPage from './pages/CategoriesPage';
import ProtectedRoute from './components/ProtectedRoute';
import ProductsPage from './pages/ProductsPage';
import AmmanAreasPage from './pages/AmmanAreasPage';
import SalesPage from './pages/SalesPage';
import ReturnInvoicePage from './pages/ReturnInvoicePage';
import ReturnInvoiceDetailPage from './pages/ReturnInvoiceDetailPage';
import SalesRepOrdersPage from './pages/SalesRepOrdersPage';
import ShopsPage from './pages/ShopsPage';
import UsersPage from './pages/UsersPage';
import SwiperPage from './pages/SwiperPage';
import OrdersPage from './pages/OrdersPage';
import VacationsPage from './pages/VacationsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      retry: (failureCount, error) => {
        // Don't retry on 401 errors
        if (error?.response?.status === 401) return false;
        return failureCount < 3;
      },
    },
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/PrivacyPolicy/" element={<PrivacyPolicy />} />
            <Route
              path="/login"
              element={
                <AuthProvider>
                  <Login />
                </AuthProvider>
              }
            />
            <Route
              path="/"
              element={
                <AuthProvider>
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                </AuthProvider>
              }
            >
                <Route index element={<Dashboard />} />
                <Route path="trademarks" element={<TrademarksPage />} />
                <Route path="categories" element={<CategoriesPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="amman-areas" element={<AmmanAreasPage />} />
                <Route path="sales" element={<SalesPage />} />
                <Route path="sales/:saleId/return-invoice" element={<ReturnInvoicePage />} />
                <Route
                  path="sales/:saleId/return-invoice/:invoiceId"
                  element={<ReturnInvoiceDetailPage />}
                />
                <Route path="sales/:saleId/orders" element={<SalesRepOrdersPage />} />
                <Route path="shops" element={<ShopsPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="swiper" element={<SwiperPage />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="vacations" element={<VacationsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;